import { FireworksColor } from "./fireworks_types.js";
import { Vector3 } from "../../core/types/math_types.js";

export const FIREWORKS_COLORS: Map<FireworksColor, Vector3> = new Map( [
  [FireworksColor.Orange, { x: 1, y: 0.596, z: 0.329 }],
  [FireworksColor.Red,    { x: 1, y: 0.196, z: 0.156 }],
  [FireworksColor.Green,  { x: 0.235, y: 1, z: 0.235 }],
  [FireworksColor.Blue,   { x: 0.156, y: 0.313, z: 1 }],
  [FireworksColor.Purple, { x: 0.313, y: 0.156, z: 1 }],
] );

export const LIFE_SPAN_TRAIL  : number = 700;
export const RATE             : number = 0.2;
export const AMPLITUDE_TRAIL  : number = 15;